/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
	init: (app, gsap) => {
		// app.dump('learn.js');

		let cards = document.querySelectorAll(".card-ressource");
		let step = 5;
		$('#showMore button').on("click", function () {
			let hiddenCards = document.querySelectorAll(".card-ressource.hide");


			// console.log(hiddenCards.length)

			if (hiddenCards.length > 0) {
				$(".card-ressource.hide").removeClass("hide");
				$("#showMore").hide();
			}


		})

	}
}

